import { render, staticRenderFns } from "./collectionDialog.vue?vue&type=template&id=39a809ea&"
import script from "./collectionDialog.vue?vue&type=script&lang=js&"
export * from "./collectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports